// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.delete-btn[data-v-23ed194a]{\n  padding:0;\n  color:#5e72e4;\n  font-weight:700;\n}\n.delete-btn[data-v-23ed194a]:focus,\n.delete-btn[data-v-23ed194a]:hover {\n  box-shadow:none;\n  text-decoration:underline;\n}\n.el-table__body-wrapper[data-v-23ed194a] {\n    overflow: auto;\n    width: 100%;\n    max-height: 600px;\n}\n.cat-col[data-v-23ed194a] {\n  width: 70%;\n}\n   \n", ""]);
// Exports
module.exports = exports;
